// A configuration has the same identity regardless of the order options were chosen.
export function normalizeSelections(selections) {
  if (!selections || typeof selections !== 'object' || Array.isArray(selections)) return {};
  return Object.fromEntries(Object.entries(selections)
    .filter(([type, value]) => type && typeof value === 'string' && value.length > 0)
    .sort(([left], [right]) => left.localeCompare(right)));
}

export function getItemSelections(item) {
  const selected = normalizeSelections(item?.selected_components);
  if (Object.keys(selected).length) return selected;
  return normalizeSelections(Object.fromEntries((item?.component_selections || [])
    .filter(selection => selection?.component_type_id && selection?.value_id)
    .map(selection => [selection.component_type_id, selection.value_id])));
}

export function cartItemKey(item) {
  return JSON.stringify([item.product_id, item.variant_id || null, getItemSelections(item)]);
}

export function matchesCartItem(item, productId, variantId, selections) {
  return cartItemKey(item) === cartItemKey({
    product_id: productId, variant_id: variantId, selected_components: selections,
  });
}

export function productDetailLink(productId, variantId = null, selections = {}) {
  const query = new URLSearchParams();
  if (variantId) query.set('variant', variantId);
  Object.entries(normalizeSelections(selections)).forEach(([type, value]) => {
    query.set(`option.${type}`, value);
  });
  const search = query.toString();
  return `/products/${encodeURIComponent(productId)}${search ? `?${search}` : ''}`;
}
